import { FC, ReactElement } from 'react';

import { IPropsFooterBottomBanner } from './model';

const FooterBottomBanner: FC<IPropsFooterBottomBanner> = (): ReactElement | null => null;

export default FooterBottomBanner;
